<!-- ==================================== POPUP : GRAPHS (STARTS) ============================================== -->

<!-- <div class="t-popup popup-graphs" style='display: block;height:100%'> -->
<div [class]="examService.isForm && !examService.isClinicsExam && ! pdfToShow ? 't-popup popup-graphs form':'t-popup popup-graphs'"
    style='display: block;height:100%'>

    <div class="popup-close"></div>
    <div class="popup-frame">
        <div class="popup-body">
        <ng-container *ngIf="!signatureService.isExamSigned(examService.examObject) && (!examService.isForm || examService.isClinicsExam)">
            <h2>Report Preview</h2>
            <div *ngIf="!signatureService.isExamSigned(examService.examObject) && signature && isPreviewGenerated && !isPDFLoading"
                style="padding: 0.5em">
                <strong>
                    Are you sure you want to sign this exam? This will lock the exam.
                </strong>
                <button (click)="handleSignAndPrint()" class="confirm--btn">
                    Yes + Print
                </button>
                <button (click)="handleSign()" class="confirm--btn">
                    Yes
                </button>
                <button (click)="closed.emit(null)" class="cancel--btn">
                    Cancel
                </button>
            </div>
        </ng-container>
        <div *ngIf="!examService.signed && signature && examService.isForm && !examService.isClinicsExam" style="padding: 0.5em">
            Are you sure you want to sign this form?
            <span (click)="closed.emit('sign')" style="margin-left: 2em; cursor: pointer">Yes</span>
            <span (click)="closed.emit(null)" style="margin-left: 2em; cursor: pointer">Cancel</span>
        </div>
        <ng-container>
           
            <div class="graphs-container">
                <div class="l-flex-c t-set" *ngIf="ShowOptions">
                    <div class="t-set-title" *ngIf="!examService.isForm || examService.isClinicsExam">
                        <div class="l-flex-c">
                            <label>
                                <input type="checkbox" name="gestation_TEMP_name_0" class="custom-check -sq" value="y"
                                    [(ngModel)]="pdf.printImages" />
                                <i  (click)="showGallery=true" class="customInput-display"></i>
                                <span>
                                    Print selected Images
                                </span>
                            </label>
                            <label *ngIf="pdf.printImages">
                                &nbsp;
                                <select [(ngModel)]="pdf.perPage" class="t-select t-field menstural-field">
                                    <option value="2">2</option>
                                    <option value="6">6</option>
                                </select>
                                <span>
                                    Per Page
                                </span>
                            </label>
                            <label [ngStyle]="disableNewTab ? { 'opacity': '0.65'} : {}">
                                <input [disabled]="disableNewTab" type="checkbox" name="gestation_TEMP_name_0" class="custom-check -sq" value="y"
                                    [(ngModel)]="pdf.newTab" />
                                <i [ngStyle]="disableNewTab ? {'cursor': 'default'} : {}" class="customInput-display"></i>
                                <span>
                                    Open in new tab
                                </span>
                            </label>
                            <label *ngIf="examService.ExamType !== 'Hemorrhoids Treatment'">
                                <input type="checkbox" name="gestation_TEMP_name_0" class="custom-check -sq" [value]="false"
                                    [(ngModel)]="courseOfExam" (ngModelChange)="gastroService.printCourseOfExam($event)"  />
                                <i class="customInput-display"></i>
                                <span>
                                    Print Course of Exam
                                </span>
                            </label>
                            <label *ngIf="login.letterhead">
                                <input type="checkbox" name="gestation_TEMP_name_0" class="custom-check -sq" value="y"
                                    [(ngModel)]="pdf.letterhead" />
                                <i class="customInput-display"></i>
                                <span>
                                    Use preprinted paper
                                </span>
                            </label>

                        </div>
                    </div>
                    <div>
                        <label *ngIf="examService.isForm">
                            <input type="checkbox" name="gestation_TEMP_name_0" class="custom-check -sq" value="y"
                                [(ngModel)]="pdf.newTab" />
                            <i class="customInput-display"></i>
                            <span>
                                Open in new tab
                            </span>
                        </label>
                        <label for="select_fetus" class="t-select-label" style='margin-left: 1em;' >Language</label>
                        <select id="select_fetus" class="t-field t-select" [(ngModel)]="pdf.Lang" >
                            <option value='en-US'>English</option>
                            <option value='he-IL'>עברית</option>
                            <!--<option value='ar-JO'>عربى</option>
                                    <option value='it-IT'>Italiano</option>
                                    <option value='es-ES'>Español</option>-->
                        </select>
                    </div>
                    <div *ngIf="! login.printStyle && ! login.isCardio">
                        <label for="select_fetus" class="t-select-label" style='margin-left: 1em;'>Print Style</label>
                        <select id="select_fetus" class="t-field t-select" [(ngModel)]="pdf.Style">
                            <option value='simple'>Plain</option>
                            <option value='fancy' *ngIf="! login.isUSG">Decorated</option>
                        </select>
                    </div>
                    <div  style="width:fit-content;margin-top: 1em;" *ngIf="!signatureService.isExamSigned(examService.examObject) && examService.ExamType !== 'Consultation Letter' && examService.ExamType !== 'Clinics' && examService.ExamType !== 'consultation and follow up with media'">
                        <span class="t-menu">Edit Exam Title to:
                            <select class="t-select color" #Title [(ngModel)]="newTitle"
                                (ngModelChange)="onNewTitleChange()"
                                [ngClass]="newTitle? 'is-invalid':''" [disabled]="examService.isClosed">
                                <option [ngValue]="" disabled>Please select a title</option>
                                <option *ngFor="let c of examService.CustomTitles" [value]="c.Title">{{c.Title}}</option>
                            </select></span>
                    </div>
                    <button class="search-btn"
                    (click)="getPDF((!signatureService.isExamSigned(examService.examObject)) ? 'preview' : '')"
                    style="width: 4em; margin-left: 1em"
                    *ngIf="showGo">
                        Go
                    </button>
                    <!-- <button class="search-btn" (click)="resendChameleon()"
                        style="width: 12em; position: absolute;right: 0" *ngIf="chameleon">Resend to Chameleon</button> -->
                </div>
                <!-- <button class="search-btn" (click)="resendChameleon()"
                    style="width: 12em;margin-left: auto;margin-right: 2em;margin-top: -2.5em;"
                    *ngIf="login.hasChameleon && chameleon && ! ShowOptions && examService.PregCopied">Resend to
                    {{login.altArchiveName ? login.altArchiveName : 'Chameleon'}}</button> -->
                <app-gallery *ngIf="pdf.printImages && showGallery && ShowOptions" style="width:100%" [forprint]="true">
                </app-gallery>
                <embed *ngIf="!isPDFLoading && pdfToShow != null" [src]="pdfToShow" type="application/pdf"
                    style='width:95vw;height:80vh;z-index:1'>
                <img *ngIf="isPDFLoading" src="../../assets/images/Wedges.svg"
                    style='z-index:0;margin-left: auto;margin-right:auto;position: absolute;left: 0; right: 0;top: 40vh'>
            </div>
        </ng-container>
            <button type="button" class="popup-close-button" (click)="closed.emit()">Close printout</button>
        </div>
    </div>

</div>

<!-- ===================================== POPUP : GRAPHS (END)  =============================================== -->